import { Modal, Button, Space } from "antd";
import { connect, useSelector } from "react-redux";
import { ReactComponent as GoogleCalendarIcon } from '../../../assets/images/google_calendar.svg'
import  { ReactComponent as OutlookCalendarIcon } from '../../../assets/images/outlook-icon.svg'

const ChooseCalendarProviderModal = ({ visible, onCancel, onSelectProvider }) => (
  <Modal
    title="Choose a Calendar Provider"
    open={visible}
    onCancel={onCancel}
    footer={null}
  >
          <Space direction="vertical" style={{ width: '100%' }}>
              <Button
                block
                onClick={() => onSelectProvider("google")}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <GoogleCalendarIcon style={{ width: 24, height: 24, marginRight: 8 }} />
                <span>Google Calendar</span>
              </Button>
              <Button
                block
                onClick={() => onSelectProvider("outlook")}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <OutlookCalendarIcon style={{ width: 24, height: 24, marginRight: 8 }} />
                <span>Outlook Calendar</span>
              </Button>
          </Space>
  </Modal>
);

const mapStateToProps = (state) => {
  return {
    calendars: state.calendar.calendars,
    currentCalendar: state.calendar.currentCalendar,
    schedules: state.schedule.schedules,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onRequestCalendars: () => requestCalendars(dispatch),
    onReceiveCalendar: (Color, BgColor, Name, Id, selected) =>
      dispatch(receiveCalendar(Color, BgColor, Name, Id, selected)),
    onSetCalendar: (calendar) => dispatch(setCalendar(calendar)),
    onRequestSchedules: () => requestSchedules(dispatch),
    onReceiveSchedule: (
      Name,
      description,
      Recurence,
      Category,
      Location,
      calendarId,
      id,
      Start,
      End,
      RoleGroupId
    ) =>
      dispatch(
        receiveSchedule(
          Name,
          description,
          Recurence,
          Category,
          Location,
          calendarId,
          id,
          Start,
          End,
          RoleGroupId
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseCalendarProviderModal);